import script from "./core.vue?vue&type=script&setup=true&lang=js"
export * from "./core.vue?vue&type=script&setup=true&lang=js"

import "./core.vue?vue&type=style&index=0&id=90e1b086&lang=scss&scoped=true"
import "./core.vue?vue&type=style&index=1&id=90e1b086&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90e1b086"]])

export default __exports__